import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useSiteConfig } from '../contexts/SiteConfigContext';
import ForgotPasswordClassic from './forgot/ForgotPasswordClassic';
import ForgotPasswordMinimal from './forgot/ForgotPasswordMinimal';
import ForgotPasswordGlass from './forgot/ForgotPasswordGlass';

// See LoginPage.jsx — same dispatcher pattern. The 3 variants each
// own the full 3-step reset flow via useForgotPasswordForm, so this
// wrapper just owns the logged-in redirect + config-loading gate.
const VARIANTS = {
  classic: ForgotPasswordClassic,
  modern:  ForgotPasswordMinimal,
  bold:    ForgotPasswordGlass,
};

const ForgotPasswordPage = () => {
  const user = useSelector((state) => state.auth.user);
  const location = useLocation();
  const { siteConfig, loaded: configLoaded } = useSiteConfig();

  if (user) {
    // Already logged in — bounce them to wherever they were trying to
    // reach, not always /home. Falls back to /home if no from-state.
    const params = new URLSearchParams(location.search);
    const dest = params.get('returnTo')
      || (location.state?.from?.pathname
          ? location.state.from.pathname + (location.state.from.search || '')
          : null)
      || '/home';
    return <Navigate to={dest} replace />;
  }

  if (!configLoaded) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white dark:bg-[#0a0a0a]">
        <Loader2 className="w-8 h-8 animate-spin text-gray-400" />
      </div>
    );
  }

  const Variant = VARIANTS[siteConfig.auth_theme] || ForgotPasswordClassic;
  return <Variant />;
};

export default ForgotPasswordPage;
